// src/pages/NotificationsPage.js
import React, { useEffect, useState } from 'react';
import { http } from "../lib/axios";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  Box,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { formatDistanceToNow, parseISO } from 'date-fns';
import ContextHelpButton from '../components/ContextHelpButton';

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const token = localStorage.getItem('access_token');

  const fetchNotifications = async () => {
    try {
      const res = await http.get('/notifications/');
      setNotifications(res.data);
    } catch (err) {
      console.error('Failed to fetch notifications:', err);
    }
  };

  const markAsRead = async (id) => {
    try {
      http.post(`/notifications/${id}/mark_read/`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(notifications.map(n => n.id === id ? { ...n, is_read: true } : n));
    } catch (err) {
      console.error('Failed to mark notification as read:', err);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <Container sx={{ mt: 5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 0 }}>Notifications</Typography>
        <ContextHelpButton section="messaging-help" title="Help for notifications" />
      </Box>
      <List>
        {notifications.map(notification => (
          <div key={notification.id}>
            <ListItem selected={!notification.is_read}>
              <ListItemText
                primary={notification.message}
                secondary={formatDistanceToNow(parseISO(notification.created_at))} ago
              />
              {!notification.is_read && (
                <ListItemSecondaryAction>
                  <IconButton onClick={() => markAsRead(notification.id)}>
                    <CheckIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              )}
            </ListItem>
            <Divider />
          </div>
        ))}
        {notifications.length === 0 && (
          <Typography>No notifications to show.</Typography>
        )}
      </List>
    </Container>
  );
}
